import script from "./ScientificScopesItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ScientificScopesItem.vue?vue&type=script&setup=true&lang=js"

import "./ScientificScopesItem.vue?vue&type=style&index=0&id=e6384a0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6384a0a"]])

export default __exports__